export const pullApiOptions = [
  { label: "SOAP Based", value: "soap_based" },
  { label: "RESTful/JSON", value: "restful_json" },
];

export const inHouseDevelopmentTeamOptions = [
  { label: "Yes, I have an In-house development team", value: "yes" },
  { label: "No, I am using 3rd Party Vendor", value: "no" },
];

export const isPciCompliantOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
export const isPushApiNotificationOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export const sendPushNotificationOptions = [
  { label: "Client Server", value: "client_server" },
  { label: "SMPP", value: "smpp" },
  { label: "Other", value: "other" },
];